export const PATIENT_SOURCE = "patient";
export const UPLOAD_SOURCE = "upload";
